/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Admin BFF API
 * Authentication and admin gateway for the AvilaRoffe platform.
 * OpenAPI spec version: 1.0
 */
import type {
  ApplicationsErrorResponse,
  GetApplications200,
  GetApplicationsSlug200,
  GetApplicationsSlugCredentials200,
  GetApplicationsSlugEnvironments200,
  GetApplicationsSlugEnvironmentsEnvSlugSecrets200,
  GetApplicationsSlugSettings200,
  GetApplicationsSlugTenants200,
  PatchApplicationsSlug200,
  PatchApplicationsSlugEnvironmentsEnvSlug200,
  PostApplications201,
  PostApplicationsSlugCredentials201,
  PostApplicationsSlugEnvironments201,
  PostApplicationsSlugEnvironmentsEnvSlugSecrets201,
  PostApplicationsSlugTenants201,
  PutApplicationsSlugAvatar200,
  PutApplicationsSlugAvatarBody,
  PutApplicationsSlugSettings200
} from '../adminBFFAPI.schemas';

import { adminBffFetch } from '../../mutator';

/**
 * @summary List all applications
 */
export type getApplicationsResponse200 = {
  data: GetApplications200
  status: 200
}

export type getApplicationsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type getApplicationsResponseSuccess = (getApplicationsResponse200) & {
  headers: Headers;
};
export type getApplicationsResponseError = (getApplicationsResponse500) & {
  headers: Headers;
};

export type getApplicationsResponse = (getApplicationsResponseSuccess | getApplicationsResponseError)

export const getGetApplicationsUrl = () => {


  

  return `/applications`
}

export const getApplications = async ( options?: RequestInit): Promise<getApplicationsResponse> => {
  
  return adminBffFetch<getApplicationsResponse>(getGetApplicationsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Create a new application
 */
export type postApplicationsResponse201 = {
  data: PostApplications201
  status: 201
}

export type postApplicationsResponse400 = {
  data: ApplicationsErrorResponse
  status: 400
}

export type postApplicationsResponse409 = {
  data: ApplicationsErrorResponse
  status: 409
}

export type postApplicationsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type postApplicationsResponseSuccess = (postApplicationsResponse201) & {
  headers: Headers;
};
export type postApplicationsResponseError = (postApplicationsResponse400 | postApplicationsResponse409 | postApplicationsResponse500) & {
  headers: Headers;
};

export type postApplicationsResponse = (postApplicationsResponseSuccess | postApplicationsResponseError)

export const getPostApplicationsUrl = () => {


  

  return `/applications`
}

export const postApplications = async ( options?: RequestInit): Promise<postApplicationsResponse> => {
  
  return adminBffFetch<postApplicationsResponse>(getPostApplicationsUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


/**
 * @summary Get an application by slug
 */
export type getApplicationsSlugResponse200 = {
  data: GetApplicationsSlug200
  status: 200
}

export type getApplicationsSlugResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type getApplicationsSlugResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type getApplicationsSlugResponseSuccess = (getApplicationsSlugResponse200) & {
  headers: Headers;
};
export type getApplicationsSlugResponseError = (getApplicationsSlugResponse404 | getApplicationsSlugResponse500) & {
  headers: Headers;
};

export type getApplicationsSlugResponse = (getApplicationsSlugResponseSuccess | getApplicationsSlugResponseError)

export const getGetApplicationsSlugUrl = (slug: string,) => {


  

  return `/applications/${slug}`
}

export const getApplicationsSlug = async (slug: string, options?: RequestInit): Promise<getApplicationsSlugResponse> => {
  
  return adminBffFetch<getApplicationsSlugResponse>(getGetApplicationsSlugUrl(slug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Delete an application
 */
export type deleteApplicationsSlugResponse204 = {
  data: void
  status: 204
}

export type deleteApplicationsSlugResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type deleteApplicationsSlugResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type deleteApplicationsSlugResponseSuccess = (deleteApplicationsSlugResponse204) & {
  headers: Headers;
};
export type deleteApplicationsSlugResponseError = (deleteApplicationsSlugResponse404 | deleteApplicationsSlugResponse500) & {
  headers: Headers;
};

export type deleteApplicationsSlugResponse = (deleteApplicationsSlugResponseSuccess | deleteApplicationsSlugResponseError)

export const getDeleteApplicationsSlugUrl = (slug: string,) => {


  

  return `/applications/${slug}`
}

export const deleteApplicationsSlug = async (slug: string, options?: RequestInit): Promise<deleteApplicationsSlugResponse> => {
  
  return adminBffFetch<deleteApplicationsSlugResponse>(getDeleteApplicationsSlugUrl(slug),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


/**
 * @summary Update an application
 */
export type patchApplicationsSlugResponse200 = {
  data: PatchApplicationsSlug200
  status: 200
}

export type patchApplicationsSlugResponse400 = {
  data: ApplicationsErrorResponse
  status: 400
}

export type patchApplicationsSlugResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type patchApplicationsSlugResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type patchApplicationsSlugResponseSuccess = (patchApplicationsSlugResponse200) & {
  headers: Headers;
};
export type patchApplicationsSlugResponseError = (patchApplicationsSlugResponse400 | patchApplicationsSlugResponse404 | patchApplicationsSlugResponse500) & {
  headers: Headers;
};

export type patchApplicationsSlugResponse = (patchApplicationsSlugResponseSuccess | patchApplicationsSlugResponseError)

export const getPatchApplicationsSlugUrl = (slug: string,) => {


  

  return `/applications/${slug}`
}

export const patchApplicationsSlug = async (slug: string, options?: RequestInit): Promise<patchApplicationsSlugResponse> => {
  
  return adminBffFetch<patchApplicationsSlugResponse>(getPatchApplicationsSlugUrl(slug),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}


/**
 * @summary Upload an avatar image for an application
 */
export type putApplicationsSlugAvatarResponse200 = {
  data: PutApplicationsSlugAvatar200
  status: 200
}

export type putApplicationsSlugAvatarResponse400 = {
  data: ApplicationsErrorResponse
  status: 400
}

export type putApplicationsSlugAvatarResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type putApplicationsSlugAvatarResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type putApplicationsSlugAvatarResponseSuccess = (putApplicationsSlugAvatarResponse200) & {
  headers: Headers;
};
export type putApplicationsSlugAvatarResponseError = (putApplicationsSlugAvatarResponse400 | putApplicationsSlugAvatarResponse404 | putApplicationsSlugAvatarResponse500) & {
  headers: Headers;
};

export type putApplicationsSlugAvatarResponse = (putApplicationsSlugAvatarResponseSuccess | putApplicationsSlugAvatarResponseError)

export const getPutApplicationsSlugAvatarUrl = (slug: string,) => {


  

  return `/applications/${slug}/avatar`
}

export const putApplicationsSlugAvatar = async (slug: string,
    putApplicationsSlugAvatarBody: PutApplicationsSlugAvatarBody, options?: RequestInit): Promise<putApplicationsSlugAvatarResponse> => {
    const formData = new FormData();
formData.append(`file`, putApplicationsSlugAvatarBody.file)

  return adminBffFetch<putApplicationsSlugAvatarResponse>(getPutApplicationsSlugAvatarUrl(slug),
  {      
    ...options,
    method: 'PUT'
    ,
    body: 
      formData,
  }
);}


/**
 * @summary List credentials for an application
 */
export type getApplicationsSlugCredentialsResponse200 = {
  data: GetApplicationsSlugCredentials200
  status: 200
}

export type getApplicationsSlugCredentialsResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type getApplicationsSlugCredentialsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type getApplicationsSlugCredentialsResponseSuccess = (getApplicationsSlugCredentialsResponse200) & {
  headers: Headers;
};
export type getApplicationsSlugCredentialsResponseError = (getApplicationsSlugCredentialsResponse404 | getApplicationsSlugCredentialsResponse500) & {
  headers: Headers;
};

export type getApplicationsSlugCredentialsResponse = (getApplicationsSlugCredentialsResponseSuccess | getApplicationsSlugCredentialsResponseError)

export const getGetApplicationsSlugCredentialsUrl = (slug: string,) => {


  

  return `/applications/${slug}/credentials`
}

export const getApplicationsSlugCredentials = async (slug: string, options?: RequestInit): Promise<getApplicationsSlugCredentialsResponse> => {
  
  return adminBffFetch<getApplicationsSlugCredentialsResponse>(getGetApplicationsSlugCredentialsUrl(slug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Create a credential for an application
 */
export type postApplicationsSlugCredentialsResponse201 = {
  data: PostApplicationsSlugCredentials201
  status: 201
}

export type postApplicationsSlugCredentialsResponse400 = {
  data: ApplicationsErrorResponse
  status: 400
}

export type postApplicationsSlugCredentialsResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type postApplicationsSlugCredentialsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type postApplicationsSlugCredentialsResponseSuccess = (postApplicationsSlugCredentialsResponse201) & {
  headers: Headers;
};
export type postApplicationsSlugCredentialsResponseError = (postApplicationsSlugCredentialsResponse400 | postApplicationsSlugCredentialsResponse404 | postApplicationsSlugCredentialsResponse500) & {
  headers: Headers;
};

export type postApplicationsSlugCredentialsResponse = (postApplicationsSlugCredentialsResponseSuccess | postApplicationsSlugCredentialsResponseError)

export const getPostApplicationsSlugCredentialsUrl = (slug: string,) => {


  

  return `/applications/${slug}/credentials`
}

export const postApplicationsSlugCredentials = async (slug: string, options?: RequestInit): Promise<postApplicationsSlugCredentialsResponse> => {
  
  return adminBffFetch<postApplicationsSlugCredentialsResponse>(getPostApplicationsSlugCredentialsUrl(slug),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


/**
 * @summary Delete a credential from an application
 */
export type deleteApplicationsSlugCredentialsCredIDResponse204 = {
  data: void
  status: 204
}

export type deleteApplicationsSlugCredentialsCredIDResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type deleteApplicationsSlugCredentialsCredIDResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type deleteApplicationsSlugCredentialsCredIDResponseSuccess = (deleteApplicationsSlugCredentialsCredIDResponse204) & {
  headers: Headers;
};
export type deleteApplicationsSlugCredentialsCredIDResponseError = (deleteApplicationsSlugCredentialsCredIDResponse404 | deleteApplicationsSlugCredentialsCredIDResponse500) & {
  headers: Headers;
};

export type deleteApplicationsSlugCredentialsCredIDResponse = (deleteApplicationsSlugCredentialsCredIDResponseSuccess | deleteApplicationsSlugCredentialsCredIDResponseError)

export const getDeleteApplicationsSlugCredentialsCredIDUrl = (slug: string,
    credID: string,) => {


  

  return `/applications/${slug}/credentials/${credID}`
}

export const deleteApplicationsSlugCredentialsCredID = async (slug: string,
    credID: string, options?: RequestInit): Promise<deleteApplicationsSlugCredentialsCredIDResponse> => {
  
  return adminBffFetch<deleteApplicationsSlugCredentialsCredIDResponse>(getDeleteApplicationsSlugCredentialsCredIDUrl(slug,credID),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


/**
 * @summary List environments for an application
 */
export type getApplicationsSlugEnvironmentsResponse200 = {
  data: GetApplicationsSlugEnvironments200
  status: 200
}

export type getApplicationsSlugEnvironmentsResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type getApplicationsSlugEnvironmentsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type getApplicationsSlugEnvironmentsResponseSuccess = (getApplicationsSlugEnvironmentsResponse200) & {
  headers: Headers;
};
export type getApplicationsSlugEnvironmentsResponseError = (getApplicationsSlugEnvironmentsResponse404 | getApplicationsSlugEnvironmentsResponse500) & {
  headers: Headers;
};

export type getApplicationsSlugEnvironmentsResponse = (getApplicationsSlugEnvironmentsResponseSuccess | getApplicationsSlugEnvironmentsResponseError)

export const getGetApplicationsSlugEnvironmentsUrl = (slug: string,) => {


  

  return `/applications/${slug}/environments`
}

export const getApplicationsSlugEnvironments = async (slug: string, options?: RequestInit): Promise<getApplicationsSlugEnvironmentsResponse> => {
  
  return adminBffFetch<getApplicationsSlugEnvironmentsResponse>(getGetApplicationsSlugEnvironmentsUrl(slug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Create an environment for an application
 */
export type postApplicationsSlugEnvironmentsResponse201 = {
  data: PostApplicationsSlugEnvironments201
  status: 201
}

export type postApplicationsSlugEnvironmentsResponse400 = {
  data: ApplicationsErrorResponse
  status: 400
}

export type postApplicationsSlugEnvironmentsResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type postApplicationsSlugEnvironmentsResponse409 = {
  data: ApplicationsErrorResponse
  status: 409
}

export type postApplicationsSlugEnvironmentsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type postApplicationsSlugEnvironmentsResponseSuccess = (postApplicationsSlugEnvironmentsResponse201) & {
  headers: Headers;
};
export type postApplicationsSlugEnvironmentsResponseError = (postApplicationsSlugEnvironmentsResponse400 | postApplicationsSlugEnvironmentsResponse404 | postApplicationsSlugEnvironmentsResponse409 | postApplicationsSlugEnvironmentsResponse500) & {
  headers: Headers;
};

export type postApplicationsSlugEnvironmentsResponse = (postApplicationsSlugEnvironmentsResponseSuccess | postApplicationsSlugEnvironmentsResponseError)

export const getPostApplicationsSlugEnvironmentsUrl = (slug: string,) => {


  

  return `/applications/${slug}/environments`
}

export const postApplicationsSlugEnvironments = async (slug: string, options?: RequestInit): Promise<postApplicationsSlugEnvironmentsResponse> => {
  
  return adminBffFetch<postApplicationsSlugEnvironmentsResponse>(getPostApplicationsSlugEnvironmentsUrl(slug),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


/**
 * @summary Delete an environment from an application
 */
export type deleteApplicationsSlugEnvironmentsEnvSlugResponse204 = {
  data: void
  status: 204
}

export type deleteApplicationsSlugEnvironmentsEnvSlugResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type deleteApplicationsSlugEnvironmentsEnvSlugResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type deleteApplicationsSlugEnvironmentsEnvSlugResponseSuccess = (deleteApplicationsSlugEnvironmentsEnvSlugResponse204) & {
  headers: Headers;
};
export type deleteApplicationsSlugEnvironmentsEnvSlugResponseError = (deleteApplicationsSlugEnvironmentsEnvSlugResponse404 | deleteApplicationsSlugEnvironmentsEnvSlugResponse500) & {
  headers: Headers;
};

export type deleteApplicationsSlugEnvironmentsEnvSlugResponse = (deleteApplicationsSlugEnvironmentsEnvSlugResponseSuccess | deleteApplicationsSlugEnvironmentsEnvSlugResponseError)

export const getDeleteApplicationsSlugEnvironmentsEnvSlugUrl = (slug: string,
    envSlug: string,) => {


  

  return `/applications/${slug}/environments/${envSlug}`
}

export const deleteApplicationsSlugEnvironmentsEnvSlug = async (slug: string,
    envSlug: string, options?: RequestInit): Promise<deleteApplicationsSlugEnvironmentsEnvSlugResponse> => {
  
  return adminBffFetch<deleteApplicationsSlugEnvironmentsEnvSlugResponse>(getDeleteApplicationsSlugEnvironmentsEnvSlugUrl(slug,envSlug),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


/**
 * @summary Update an environment
 */
export type patchApplicationsSlugEnvironmentsEnvSlugResponse200 = {
  data: PatchApplicationsSlugEnvironmentsEnvSlug200
  status: 200
}

export type patchApplicationsSlugEnvironmentsEnvSlugResponse400 = {
  data: ApplicationsErrorResponse
  status: 400
}

export type patchApplicationsSlugEnvironmentsEnvSlugResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type patchApplicationsSlugEnvironmentsEnvSlugResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type patchApplicationsSlugEnvironmentsEnvSlugResponseSuccess = (patchApplicationsSlugEnvironmentsEnvSlugResponse200) & {
  headers: Headers;
};
export type patchApplicationsSlugEnvironmentsEnvSlugResponseError = (patchApplicationsSlugEnvironmentsEnvSlugResponse400 | patchApplicationsSlugEnvironmentsEnvSlugResponse404 | patchApplicationsSlugEnvironmentsEnvSlugResponse500) & {
  headers: Headers;
};

export type patchApplicationsSlugEnvironmentsEnvSlugResponse = (patchApplicationsSlugEnvironmentsEnvSlugResponseSuccess | patchApplicationsSlugEnvironmentsEnvSlugResponseError)

export const getPatchApplicationsSlugEnvironmentsEnvSlugUrl = (slug: string,
    envSlug: string,) => {


  

  return `/applications/${slug}/environments/${envSlug}`
}

export const patchApplicationsSlugEnvironmentsEnvSlug = async (slug: string,
    envSlug: string, options?: RequestInit): Promise<patchApplicationsSlugEnvironmentsEnvSlugResponse> => {
  
  return adminBffFetch<patchApplicationsSlugEnvironmentsEnvSlugResponse>(getPatchApplicationsSlugEnvironmentsEnvSlugUrl(slug,envSlug),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}


/**
 * @summary List secrets for an environment
 */
export type getApplicationsSlugEnvironmentsEnvSlugSecretsResponse200 = {
  data: GetApplicationsSlugEnvironmentsEnvSlugSecrets200
  status: 200
}

export type getApplicationsSlugEnvironmentsEnvSlugSecretsResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type getApplicationsSlugEnvironmentsEnvSlugSecretsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type getApplicationsSlugEnvironmentsEnvSlugSecretsResponseSuccess = (getApplicationsSlugEnvironmentsEnvSlugSecretsResponse200) & {
  headers: Headers;
};
export type getApplicationsSlugEnvironmentsEnvSlugSecretsResponseError = (getApplicationsSlugEnvironmentsEnvSlugSecretsResponse404 | getApplicationsSlugEnvironmentsEnvSlugSecretsResponse500) & {
  headers: Headers;
};

export type getApplicationsSlugEnvironmentsEnvSlugSecretsResponse = (getApplicationsSlugEnvironmentsEnvSlugSecretsResponseSuccess | getApplicationsSlugEnvironmentsEnvSlugSecretsResponseError)

export const getGetApplicationsSlugEnvironmentsEnvSlugSecretsUrl = (slug: string,
    envSlug: string,) => {


  

  return `/applications/${slug}/environments/${envSlug}/secrets`
}

export const getApplicationsSlugEnvironmentsEnvSlugSecrets = async (slug: string,
    envSlug: string, options?: RequestInit): Promise<getApplicationsSlugEnvironmentsEnvSlugSecretsResponse> => {
  
  return adminBffFetch<getApplicationsSlugEnvironmentsEnvSlugSecretsResponse>(getGetApplicationsSlugEnvironmentsEnvSlugSecretsUrl(slug,envSlug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Add a secret to an environment
 */
export type postApplicationsSlugEnvironmentsEnvSlugSecretsResponse201 = {
  data: PostApplicationsSlugEnvironmentsEnvSlugSecrets201
  status: 201
}

export type postApplicationsSlugEnvironmentsEnvSlugSecretsResponse400 = {
  data: ApplicationsErrorResponse
  status: 400
}

export type postApplicationsSlugEnvironmentsEnvSlugSecretsResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type postApplicationsSlugEnvironmentsEnvSlugSecretsResponse409 = {
  data: ApplicationsErrorResponse
  status: 409
}

export type postApplicationsSlugEnvironmentsEnvSlugSecretsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type postApplicationsSlugEnvironmentsEnvSlugSecretsResponseSuccess = (postApplicationsSlugEnvironmentsEnvSlugSecretsResponse201) & {
  headers: Headers;
};
export type postApplicationsSlugEnvironmentsEnvSlugSecretsResponseError = (postApplicationsSlugEnvironmentsEnvSlugSecretsResponse400 | postApplicationsSlugEnvironmentsEnvSlugSecretsResponse404 | postApplicationsSlugEnvironmentsEnvSlugSecretsResponse409 | postApplicationsSlugEnvironmentsEnvSlugSecretsResponse500) & {
  headers: Headers;
};

export type postApplicationsSlugEnvironmentsEnvSlugSecretsResponse = (postApplicationsSlugEnvironmentsEnvSlugSecretsResponseSuccess | postApplicationsSlugEnvironmentsEnvSlugSecretsResponseError)

export const getPostApplicationsSlugEnvironmentsEnvSlugSecretsUrl = (slug: string,
    envSlug: string,) => {


  

  return `/applications/${slug}/environments/${envSlug}/secrets`
}

export const postApplicationsSlugEnvironmentsEnvSlugSecrets = async (slug: string,
    envSlug: string, options?: RequestInit): Promise<postApplicationsSlugEnvironmentsEnvSlugSecretsResponse> => {
  
  return adminBffFetch<postApplicationsSlugEnvironmentsEnvSlugSecretsResponse>(getPostApplicationsSlugEnvironmentsEnvSlugSecretsUrl(slug,envSlug),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


/**
 * @summary Delete a secret from an environment
 */
export type deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponse204 = {
  data: void
  status: 204
}

export type deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponseSuccess = (deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponse204) & {
  headers: Headers;
};
export type deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponseError = (deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponse404 | deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponse500) & {
  headers: Headers;
};

export type deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponse = (deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponseSuccess | deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponseError)

export const getDeleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDUrl = (slug: string,
    envSlug: string,
    credID: string,) => {


  

  return `/applications/${slug}/environments/${envSlug}/secrets/${credID}`
}

export const deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredID = async (slug: string,
    envSlug: string,
    credID: string, options?: RequestInit): Promise<deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponse> => {
  
  return adminBffFetch<deleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDResponse>(getDeleteApplicationsSlugEnvironmentsEnvSlugSecretsCredIDUrl(slug,envSlug,credID),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


/**
 * @summary Get typed application settings
 */
export type getApplicationsSlugSettingsResponse200 = {
  data: GetApplicationsSlugSettings200
  status: 200
}

export type getApplicationsSlugSettingsResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type getApplicationsSlugSettingsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type getApplicationsSlugSettingsResponseSuccess = (getApplicationsSlugSettingsResponse200) & {
  headers: Headers;
};
export type getApplicationsSlugSettingsResponseError = (getApplicationsSlugSettingsResponse404 | getApplicationsSlugSettingsResponse500) & {
  headers: Headers;
};

export type getApplicationsSlugSettingsResponse = (getApplicationsSlugSettingsResponseSuccess | getApplicationsSlugSettingsResponseError)

export const getGetApplicationsSlugSettingsUrl = (slug: string,) => {


  

  return `/applications/${slug}/settings`
}

export const getApplicationsSlugSettings = async (slug: string, options?: RequestInit): Promise<getApplicationsSlugSettingsResponse> => {
  
  return adminBffFetch<getApplicationsSlugSettingsResponse>(getGetApplicationsSlugSettingsUrl(slug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Update typed application settings
 */
export type putApplicationsSlugSettingsResponse200 = {
  data: PutApplicationsSlugSettings200
  status: 200
}

export type putApplicationsSlugSettingsResponse400 = {
  data: ApplicationsErrorResponse
  status: 400
}

export type putApplicationsSlugSettingsResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type putApplicationsSlugSettingsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type putApplicationsSlugSettingsResponseSuccess = (putApplicationsSlugSettingsResponse200) & {
  headers: Headers;
};
export type putApplicationsSlugSettingsResponseError = (putApplicationsSlugSettingsResponse400 | putApplicationsSlugSettingsResponse404 | putApplicationsSlugSettingsResponse500) & {
  headers: Headers;
};

export type putApplicationsSlugSettingsResponse = (putApplicationsSlugSettingsResponseSuccess | putApplicationsSlugSettingsResponseError)

export const getPutApplicationsSlugSettingsUrl = (slug: string,) => {


  

  return `/applications/${slug}/settings`
}

export const putApplicationsSlugSettings = async (slug: string, options?: RequestInit): Promise<putApplicationsSlugSettingsResponse> => {
  
  return adminBffFetch<putApplicationsSlugSettingsResponse>(getPutApplicationsSlugSettingsUrl(slug),
  {      
    ...options,
    method: 'PUT'
    
    
  }
);}


/**
 * @summary List tenants bound to an application
 */
export type getApplicationsSlugTenantsResponse200 = {
  data: GetApplicationsSlugTenants200
  status: 200
}

export type getApplicationsSlugTenantsResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type getApplicationsSlugTenantsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type getApplicationsSlugTenantsResponseSuccess = (getApplicationsSlugTenantsResponse200) & {
  headers: Headers;
};
export type getApplicationsSlugTenantsResponseError = (getApplicationsSlugTenantsResponse404 | getApplicationsSlugTenantsResponse500) & {
  headers: Headers;
};

export type getApplicationsSlugTenantsResponse = (getApplicationsSlugTenantsResponseSuccess | getApplicationsSlugTenantsResponseError)

export const getGetApplicationsSlugTenantsUrl = (slug: string,) => {


  

  return `/applications/${slug}/tenants`
}

export const getApplicationsSlugTenants = async (slug: string, options?: RequestInit): Promise<getApplicationsSlugTenantsResponse> => {
  
  return adminBffFetch<getApplicationsSlugTenantsResponse>(getGetApplicationsSlugTenantsUrl(slug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Bind a tenant to an application
 */
export type postApplicationsSlugTenantsResponse201 = {
  data: PostApplicationsSlugTenants201
  status: 201
}

export type postApplicationsSlugTenantsResponse400 = {
  data: ApplicationsErrorResponse
  status: 400
}

export type postApplicationsSlugTenantsResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type postApplicationsSlugTenantsResponse409 = {
  data: ApplicationsErrorResponse
  status: 409
}

export type postApplicationsSlugTenantsResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type postApplicationsSlugTenantsResponseSuccess = (postApplicationsSlugTenantsResponse201) & {
  headers: Headers;
};
export type postApplicationsSlugTenantsResponseError = (postApplicationsSlugTenantsResponse400 | postApplicationsSlugTenantsResponse404 | postApplicationsSlugTenantsResponse409 | postApplicationsSlugTenantsResponse500) & {
  headers: Headers;
};

export type postApplicationsSlugTenantsResponse = (postApplicationsSlugTenantsResponseSuccess | postApplicationsSlugTenantsResponseError)

export const getPostApplicationsSlugTenantsUrl = (slug: string,) => {


  

  return `/applications/${slug}/tenants`
}

export const postApplicationsSlugTenants = async (slug: string, options?: RequestInit): Promise<postApplicationsSlugTenantsResponse> => {
  
  return adminBffFetch<postApplicationsSlugTenantsResponse>(getPostApplicationsSlugTenantsUrl(slug),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


/**
 * @summary Unbind a tenant from an application
 */
export type deleteApplicationsSlugTenantsTenantIDResponse204 = {
  data: void
  status: 204
}

export type deleteApplicationsSlugTenantsTenantIDResponse404 = {
  data: ApplicationsErrorResponse
  status: 404
}

export type deleteApplicationsSlugTenantsTenantIDResponse500 = {
  data: ApplicationsErrorResponse
  status: 500
}
    
export type deleteApplicationsSlugTenantsTenantIDResponseSuccess = (deleteApplicationsSlugTenantsTenantIDResponse204) & {
  headers: Headers;
};
export type deleteApplicationsSlugTenantsTenantIDResponseError = (deleteApplicationsSlugTenantsTenantIDResponse404 | deleteApplicationsSlugTenantsTenantIDResponse500) & {
  headers: Headers;
};

export type deleteApplicationsSlugTenantsTenantIDResponse = (deleteApplicationsSlugTenantsTenantIDResponseSuccess | deleteApplicationsSlugTenantsTenantIDResponseError)

export const getDeleteApplicationsSlugTenantsTenantIDUrl = (slug: string,
    tenantID: string,) => {


  

  return `/applications/${slug}/tenants/${tenantID}`
}

export const deleteApplicationsSlugTenantsTenantID = async (slug: string,
    tenantID: string, options?: RequestInit): Promise<deleteApplicationsSlugTenantsTenantIDResponse> => {
  
  return adminBffFetch<deleteApplicationsSlugTenantsTenantIDResponse>(getDeleteApplicationsSlugTenantsTenantIDUrl(slug,tenantID),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


